const theme = {
  colors: {
    white: "#F6F6F8",
    backgroundPage: "#F6F6F8",
    blackGreen: "#0C5156",
    lightGreen: "#1CC98A",
    blackGray: "#105E63",
    lighGray: "#868E96",
    text: "#e1e1e6",
    primary: "#8257e6",
    headerDescription: "#105E63",
    black: "#282828",
  },
  fonts: {
    "font-weight": "400",
    "font-family": "Montserrat, sans-serif",
    "font-size": "14px",
    "font-size-768": "12px",
  },
  gridPage: {
    maxWidth: 1140,
  },
};

export default theme;
